import { Trans } from 'react-i18next';
import { BenefitAttribute, BenefitColumnsExtensionInterface } from '../../../../extension/interface/benefit-columns.extension.interface';

export class RecreationBenefitColumnsExtension extends BenefitColumnsExtensionInterface {
  getBenefitAttributes: () => BenefitAttribute[] = () => [
    {
      id: 'recreationYearlyBudget',
      accessorFn: value => value.recreationOptions?.yearlyBudget,
      header: 'RECREATION.fields.yearlyBudget',
      renderer: cell =>
        typeof cell === 'number' ? (
          <Trans i18nKey="common:money" values={{ money: cell }} />
        ) : (
          <Trans i18nKey="benefitsModule:RECREATION.individualBudget" />
        ),
      enableSorting: false,
    },
  ];
}
